import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import Login from './pages/Login';
import SupplierManagement from './pages/SupplierManagement';
import PackingListUpload from './pages/PackingListUpload';
import PackingListManager from './pages/PackingListManager';
import CargoEntry from './pages/CargoEntry';
import DeliveryNoteCreation from './pages/DeliveryNoteCreation';
import DeliveryNoteList from './pages/DeliveryNoteList';
import DeliveryNoteDetails from './pages/DeliveryNoteDetails';
import StockView from './pages/StockView';
import './App.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function App() {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Initialize from sessionStorage on mount
  useEffect(() => {
    const savedToken = sessionStorage.getItem('token');
    const savedUser = sessionStorage.getItem('user');
    
    console.log('App.jsx: Reading from sessionStorage');
    console.log('App.jsx: savedToken:', savedToken ? 'present' : 'null');
    console.log('App.jsx: savedUser:', savedUser ? 'present' : 'null');
    
    if (savedToken && savedUser) {
      try {
        setToken(savedToken);
        setUser(JSON.parse(savedUser));
        setIsAuthenticated(true);
        console.log('App.jsx: Successfully restored session');
      } catch (error) {
        console.error('App.jsx: Error parsing savedUser:', error);
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
      }
    }
    
    setLoading(false);
  }, []);

  const handleLogin = (token, userData) => {
    console.log('App.jsx: handleLogin called');
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('user', JSON.stringify(userData));
    setToken(token);
    setUser(userData);
    setIsAuthenticated(true);
    console.log('App.jsx: Login successful, token and user saved');
  };

  const handleLogout = () => {
    console.log('App.jsx: handleLogout called');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
  };

  if (loading) {
    return <div className="loading-screen">Loading...</div>;
  }

  return (
    <Router>
      {isAuthenticated && <Navigation user={user} onLogout={handleLogout} />}
      
      <Routes>
        {/* Public Routes */}
        <Route 
          path="/login" 
          element={isAuthenticated ? <Navigate to="/" /> : <Login onLogin={handleLogin} />} 
        />

        {/* Protected Routes */}
        <Route
          path="/"
          element={isAuthenticated ? <Navigate to="/inventory" /> : <Navigate to="/login" />}
        />

        <Route
          path="/inventory"
          element={isAuthenticated ? <StockView token={token} /> : <Navigate to="/login" />}
        />

        {/* Admin Routes */}
        <Route
          path="/suppliers"
          element={isAuthenticated && user?.role === 'admin' ? <SupplierManagement token={token} /> : <Navigate to="/login" />}
        />

        {/* Operations Routes */}
        <Route
          path="/packing-list-upload"
          element={isAuthenticated ? <PackingListUpload token={token} /> : <Navigate to="/login" />}
        />

        <Route
          path="/packing-lists"
          element={isAuthenticated ? <PackingListManager token={token} /> : <Navigate to="/login" />}
        />

        <Route
          path="/packing-list/:packingListId/cargo"
          element={isAuthenticated ? <CargoEntry token={token} /> : <Navigate to="/login" />}
        />

        <Route
          path="/delivery-notes/create"
          element={isAuthenticated ? <DeliveryNoteCreation token={token} /> : <Navigate to="/login" />}
        />

        <Route
          path="/delivery-notes"
          element={isAuthenticated ? <DeliveryNoteList token={token} /> : <Navigate to="/login" />}
        />

        <Route
          path="/delivery-notes/:deliveryId"
          element={isAuthenticated ? <DeliveryNoteDetails token={token} /> : <Navigate to="/login" />}
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to={isAuthenticated ? "/" : "/login"} />} />
      </Routes>
    </Router>
  );
}

export default App;
